import nxModule from 'nxModule';
import StatusBasedService from "./statusBasedService";

nxModule.factory('workingDayService', (statusService) =>
  new StatusBasedService({
    property: 'workingDay',
    statusService: statusService
  }));